import { Api } from '@/services/Api'

export default {
  getOtherSensorsData (plantId) {
    return Api().get(`/api/v1.0/otherSensorsData/${plantId}`)
  },
  getExtendedDeviceData (query) {
    return Api().post(`/api/v1.0/otherSensor`, query)
  },
  getUpsData (plantId, date) {
    return Api().get(`/api/v1.0/ups/${plantId}/${date}`)
  },
  getEmData (plantId, date) {
    return Api().get(`/api/v1.0/em/${plantId}/${date}`)
  },
  getSoilSensorData (plantId, date) {
    return Api().get(`/api/v1.0/soil-sensor/${plantId}/${date}`)
  },
  getTrackerData (plantId, date) {
    return Api().get(`/api/v1.0/tracker/${plantId}/${date}`)
  },
  getRtuPanelData (plantId, date) {
    return Api().get(`/api/v1.0/rtu-panel/${plantId}/${date}`)
  },
  getDcBatteryChargerData (plantId, date) {
    return Api().get(`/api/v1.0/dcBatteryCharger/${plantId}/${date}`)
  },
  getTransformerData (plantId, date) {
    return Api().get(`/api/v1.0/itf/${plantId}/${date}`)
  },
  getBreakerData (plantId, date) {
    return Api().get(`/api/v1.0/breaker/${plantId}/${date}`)
  },
}
